/* Americanflat header — mobile drawer menu (hamburger toggle, scrim, Esc). */
(function () {
  const toggle = document.querySelector('[data-af-menu-toggle]');
  const menu = document.querySelector('[data-af-mobile-menu]');
  const scrim = document.querySelector('[data-af-menu-scrim]');
  const closeBtn = document.querySelector('[data-af-menu-close]');
  if (!toggle || !menu) return;

  function setOpen(open) {
    menu.hidden = !open;
    if (scrim) scrim.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('af-menu-open', open);
    if (open) {
      // Let the hidden attribute clear before animating in.
      requestAnimationFrame(() => menu.classList.add('is-open'));
      if (scrim) requestAnimationFrame(() => scrim.classList.add('is-open'));
    } else {
      menu.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
    }
  }

  toggle.addEventListener('click', () => setOpen(menu.hidden));
  if (closeBtn) closeBtn.addEventListener('click', () => setOpen(false));
  if (scrim) scrim.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !menu.hidden) setOpen(false);
  });
})();

/* Cart icon → open the Dawn cart drawer when present (cart_type: drawer).
   Falls back to navigating to /cart if the drawer isn't on the page. */
(function () {
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-af-cart-toggle]');
    if (!trigger) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return; // let the link navigate
    e.preventDefault();
    drawer.open(trigger);
  });
})();

/* Keep the header cart-count badge in sync after in-drawer quantity/remove
   changes. Dawn's cart.js re-renders only the cart-drawer section here (the
   #cart-icon-bubble section was dropped — see cart-drawer.js), so the header
   badge would otherwise go stale. Listen for the cart-update event instead. */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    const count = event && event.cartData && event.cartData.item_count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-af-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  });
})();

/* Deferred nav art (see af-nav-item.liquid). Menu thumbnails ship with a 1×1
   placeholder src and their real URLs in data-*; swap them in the first time
   anyone reaches for the nav (hover, keyboard focus, touch, or the hamburger).
   Keeps menu art out of the initial DOM so search engines don't mistake a
   Cozy Home thumbnail for a frame collection's page image. */
(function () {
  // Swap every still-deferred image. Self-limiting: hydrated images lose [data-src], so
  // repeat calls match nothing and cost one cheap querySelectorAll. Safe to call often.
  function hydrateAll() {
    document.querySelectorAll('img.af-defer-img[data-src]').forEach(function (img) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.sizes) img.sizes = img.dataset.sizes;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-sizes');
    });
  }
  // One-shot wrapper for the STATIC nav art, so header pointer traffic doesn't rescan.
  var done = false;
  function hydrate() {
    if (done) return;
    done = true;
    hydrateAll();
  }
  var toggle = document.querySelector('[data-af-menu-toggle]');
  var root = document.querySelector('header.af-nav') || document.querySelector('.af-header') ||
             (toggle && toggle.closest('header, .shopify-section')) ||
             document.querySelector('header') || document.body;
  ['pointerenter', 'pointerdown', 'focusin', 'touchstart'].forEach(function (ev) {
    root.addEventListener(ev, hydrate, { passive: true, capture: true });
  });
  if (toggle) toggle.addEventListener('pointerdown', hydrate, { passive: true });
  // The cart drawer's empty-cart merchandising uses the same deferral: hydrate
  // when the cart icon is reached for, or when Dawn's <cart-drawer> flips its
  // class to open (add-to-cart opens it without touching the header).
  // ⚠️ The drawer must NOT use the one-shot `hydrate`: cart.js / cart-drawer.js replace the
  // drawer's innerHTML on every cart change, which inserts brand-new deferred placeholders.
  // With the one-shot guard already spent, the empty-cart "Popular right now" merch rendered
  // as blank tiles after a remove-to-empty. Use hydrateAll here, and also watch childList so
  // a re-render while the drawer is already open gets hydrated (no class change fires then).
  // Hydration only sets attributes, so it never re-triggers the childList observer.
  document.querySelectorAll('[data-af-cart-toggle]').forEach(function (el) {
    el.addEventListener('pointerdown', hydrateAll, { passive: true });
    el.addEventListener('focusin', hydrateAll, { passive: true });
  });
  var drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (drawer.classList.contains('active') || drawer.classList.contains('animate')) hydrateAll();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }
})();
